var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-page-frame',[_c('div',{staticClass:"adminlogin_form",style:({ minHeight: _vm.minheight })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }